export default {
  title: "Deposits",
  subtitle: "Public registry of deposited works and intellectual property records.",
  empty: "The public registry is empty.",
  detail: "Deposit",
  industry: "Industry",
  status: "Status",
  submitted: "Submitted",
  certificate: "Certificate",
  loadFailed: "Could not load deposits.",
  portal: {
    title: "Deposits portal",
    pageTitle: "Deposits dashboard",
    pageSubtitle: "Manage applications, follow moderation and download certificates in one place.",
    overview: "Overview",
    registry: "Public registry",
    my: "My deposits",
    apply: "Apply",
    moderation: "Review queue",
    navAria: "Deposits dashboard navigation",
    overviewTitle: "Dashboard overview",
    overviewSubtitle: "A summary of your applications and the moderation queue.",
    myHint: "Drafts, submitted applications and issued certificates",
    moderationHint: "Review applications and issue certificates",
    totalMy: "Total: {{count}}",
    draftsCount: "Drafts: {{count}}",
    moderationTotal: "In queue: {{count}}",
    goToSection: "Open section",
    statsLoading: "Loading summary…",
    applyTitle: "Deposit application",
    titleField: "Title",
    industryField: "Industry",
    submit: "Create and submit",
    emptyMine: "No deposits or drafts yet.",
    emptyModeration: "Moderation queue is empty.",
    drafts: "Drafts",
    deposits: "Applications",
    approve: "Approve",
    reject: "Reject",
    revision: "Request revision",
    forbidden: "You do not have permission to moderate.",
    applySuccess: "Application submitted",
    searchPlaceholder: "Search by title",
    sortNewest: "Newest first",
    sortOldest: "Oldest first",
    sortTitle: "By title",
    filters: "Registry filters",
    openRecord: "Open record “{{title}}”",
    noTitle: "Untitled",
    statusUnknown: "Status: {{status}}",
    subtitles: {
      registry: "Published deposit records.",
      my: "Drafts, submitted applications and issued certificates.",
      apply: "Title and industry; you can add the rest later.",
      moderation: "Authors' applications awaiting a decision.",
    },
    columns: { title: "Title", industry: "Industry", status: "Status", step: "Step", updated: "Updated", submitted: "Submitted", actions: "Decision" },
    draftStep: "Step {{step}} of 4",
    continueDraft: "Continue",
    rejectTitle: "Reject application",
    rejectMessage: "“{{title}}” will not be deposited. The author will see the rejection in their cabinet.",
    statuses: {
      pending_moderation: "Pending review",
      team_review: "Team review",
      confirmed: "Confirmed",
      rejected: "Rejected",
      needs_revision: "Needs revision",
      withdrawn: "Withdrawn",
    },
  },
}